import mutations from './mutations'
import currentStock from '@/api/currentStock'
import { loadItemsBuilder } from '../crudFactory'

const apiEndpoint = 'currentStock'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    getPdf ({ rootState }, data) {
      return new Promise((resolve, reject) => {
        // add print type
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        const filters = data ? data.filters : {}
        currentStock.getPdf({ businessUnitId, filters })
          .then(response => {
            const pdfData = response.data.items[0]
            resolve(pdfData)
          })
          .catch(error => reject(error))
      })
    }
  },

  mutations: {
    ...mutations
  }
}
